import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter, Truck, ShieldCheck, Package, Headphones } from "lucide-react";
import { useApp } from "../context/AppContext";

export default function Footer() {
  const { t, tr, settings, categories } = useApp();

  const features = [
    { icon: Truck, label: t("freeShipping") },
    { icon: ShieldCheck, label: t("authentic") },
    { icon: Package, label: t("securePackaging") },
    { icon: Headphones, label: t("support") },
  ];

  return (
    <footer>
      {/* Feature strip */}
      <div className="border-t border-neutral-200 bg-neutral-50">
        <div className="max-w-[1400px] mx-auto px-6 py-10 grid grid-cols-2 md:grid-cols-4 gap-8">
          {features.map((f, i) => (
            <div key={i} className="flex flex-col items-center text-center gap-3">
              <f.icon size={26} strokeWidth={1.2} style={{ color: "var(--brand)" }} />
              <span className="text-xs tracking-widest uppercase text-neutral-600 font-light">{f.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Main footer */}
      <div className="bg-neutral-900 text-neutral-300">
        <div className="max-w-[1400px] mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="brand-font text-3xl tracking-[0.25em] text-white mb-1">{settings.brandName}</div>
            <div className="text-[10px] tracking-[0.4em] text-neutral-500 uppercase mb-5">{settings.brandSub}</div>
            <p className="text-sm text-neutral-400 leading-relaxed font-light">{tr(settings.footerText) || t("footerAbout")}</p>
          </div>

          <div>
            <h4 className="text-xs tracking-widest uppercase text-white mb-5">{t("quickLinks")}</h4>
            <ul className="space-y-3 text-sm font-light">
              <li><Link to="/" className="hover:text-white transition-colors">{t("home")}</Link></li>
              <li><Link to="/shop" className="hover:text-white transition-colors">{t("shop")}</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">{t("about")}</Link></li>
              <li><Link to="/wishlist" className="hover:text-white transition-colors">{t("wishlist")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs tracking-widest uppercase text-white mb-5">{t("categories")}</h4>
            <ul className="space-y-3 text-sm font-light">
              {categories.slice(0, 5).map((c) => (
                <li key={c.id}><Link to={`/shop/${c.slug}`} className="hover:text-white transition-colors">{tr(c.name)}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs tracking-widest uppercase text-white mb-5">{t("contact")}</h4>
            <ul className="space-y-3 text-sm font-light text-neutral-400">
              <li>{tr(settings.contact.address)}</li>
              <li>{settings.contact.email}</li>
              <li>{settings.contact.phone}</li>
              <li>{tr(settings.contact.hours)}</li>
            </ul>
            <div className="flex gap-4 mt-6">
              <a href={settings.social?.instagram || "#"} target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-white transition-colors"><Instagram size={19} /></a>
              <a href={settings.social?.facebook || "#"} target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-white transition-colors"><Facebook size={19} /></a>
              <a href={settings.social?.twitter || "#"} target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-white transition-colors"><Twitter size={19} /></a>
            </div>
          </div>
        </div>
        <div className="border-t border-neutral-800">
          <div className="max-w-[1400px] mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-[11px] text-neutral-500 tracking-wide">
            <span>© {new Date().getFullYear()} {settings.brandName}. {t("rights")}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
